



































import Vue from 'vue'
import Component from 'vue-class-component'
import { Emit, Prop, Watch } from 'vue-property-decorator'
import copy from 'copy-to-clipboard'
import { ActiveEmbedBaseURL, serializeVuexStore, deserialize } from "@/util/Serialization";
import Timeline from '../../models/Timeline';

function randomStr(len : number, arr : string = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ') { 
	var ans = ''; 
	for (var i = len; i > 0; i--) { 
		ans += arr[Math.floor(Math.random() * arr.length)]; 
	} 
	return ans; 
} 

function replaceAll(target : string, search : string | RegExp, replacement : string) {
	return target.replace(new RegExp(search, 'g'), replacement);
};

@Component
export default class EmbedModal extends Vue
{
	@Prop(Array) readonly timelineids!: number[];
	
	message_key = 0
	messages : { key : number, variant : string | undefined, text : string }[] = []
	showURL = false

	computeSerializedPayload()
	{
		if (this.timelineids)
		{
			return serializeVuexStore(this.timelineids);
		}
		return serializeVuexStore();
	}

	get randomString()
	{
		return randomStr(32);
	}

	get serialized()
	{
		return this.computeSerializedPayload();
	}

	genEmbedLink(embedDataInURL = true, overrideString = 'framesrc')
	{
		let encoded = encodeURIComponent(this.serialized);
		let base = `${ActiveEmbedBaseURL()}app/e/${embedDataInURL ? encoded : overrideString}`;
		
		if (!this.timelineids || this.timelineids.length != 1)
			return base;
		
		return `${base}/timeline/${this.timelineids[0]}`
	}

	get embedLink()
	{
		return this.genEmbedLink();
	}

	get embedHTML()
	{
		let tl = ''
		for(let id of this.timelineids)
		{
			tl += id.toString()
		}

		let varName = `p${this.$store.state.project.project.id.replace(/-/g, '')}_${tl}_${this.randomString}`
		
		let dataToPass = {
			hostname: '*',
			message_name: varName
		}

		let fnName = `cv_fn_${varName}`;
		//frame.contentWindow.postMessage({call:'sendValue', value: ${this.serialized}};
		let script = `function ${fnName}() { document.getElementById("${varName}").contentWindow.postMessage({call:'sendValue', value: "${this.serialized}"}, "${ActiveEmbedBaseURL()}")}`
		 + `window.addEventListener('message', (ev)=>{ if (typeof ev.data == 'object' && ev.data.call == "${dataToPass.message_name}") ${fnName}() })`;
		
		return `<iframe id="${varName}" style="width: 100%; min-height: 700px;" src="${this.genEmbedLink(false, `framesrc_${encodeURIComponent(btoa(JSON.stringify(dataToPass)))}`)}" allowFullscreen>ClioVis embed links are not supported in this browser.  Please use an up to date version of Chrome, Firefox, or Safari.</iframe>\n` + 
		`<script>${script}<\/script>`
	}

	openAlert()
	{
		this.messages.length = 0;
		this.messages.push({ key: this.message_key++, text: 'Copied HTML to your clipboard', variant: 'success' });
	}

	copyToClipboard(str : string)
	{
		copy(str);
	}
}
